
/* injects from baggage-loader */

import {connect} from 'react-redux'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {deleteSite} from 'redux/modules/sites/actions'
import Confirm from 'components/Confirm'

export default connect((state, {name}) => {
  return {
    message: `Do you really want to delete "${name}"?`,
    ok: 'Delete'
  }
}, (dispatch, {siteId}) => {
  const dispatchCloseModal = () => dispatch(closeModal())

  return {
    onOk: () => dispatch(deleteSite(siteId)).success(dispatchCloseModal).fail(dispatchCloseModal),
    onCancel: dispatchCloseModal
  }
})(Confirm)



// WEBPACK FOOTER //
// ./client/modals/SiteDeleteConfirm/index.js